// extracted by mini-css-extract-plugin
export default {"containerTemporary":"styles_containerTemporary__Fo120","search":"styles_search__aCrDF","mobileText":"styles_mobileText__6C-cA","showcaseWrapper":"styles_showcaseWrapper__EVayX"};